var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.875 187.5L99.1812 185.944C99.1812 185.944 99.8062 162.194 91.2125 160.525C85.5875 153.975 92.0437 -119.106 112.606 159.594C108.705 161.573 105.72 164.983 104.275 169.113C103.501 175.211 103.367 181.374 103.875 187.5Z",
    fill: "url(#paint0_linear_7_24)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.412 164.556C118.91 155.149 128.481 142.387 134.012 127.756C139.544 113.124 140.81 97.2226 137.662 81.9C128.475 41.3688 106.719 28.0438 104.375 22.9563C102.353 19.7884 100.627 16.4409 99.2188 12.9563L100.95 125.888C100.95 125.888 97.3625 160.4 106.412 164.556Z",
    fill: "url(#paint1_linear_7_24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7937 166.056C96.7937 166.056 58.5375 140 60.75 93.9062C60.9564 80.0103 64.1425 66.3204 70.0932 53.7614C76.0439 41.2023 84.6205 30.0665 95.2437 21.1062C96.4852 20.0515 97.4715 18.7292 98.1286 17.2386C98.7856 15.748 99.0964 14.1279 99.0375 12.5C101.419 17.625 101.031 89.0187 101.281 97.3687C102.25 129.85 99.475 159.925 96.7937 166.056Z",
    fill: "url(#paint2_linear_7_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_24",
    x1: 72.3228,
    y1: 101.577,
    x2: 126.271,
    y2: 119.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#999875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#9B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#A09F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#A9A889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#B7B69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#C9C7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#DEDDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#F8F6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_24",
    x1: 92.1059,
    y1: 12.1493,
    x2: 115.956,
    y2: 161.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48A547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_24",
    x1: 57.4592,
    y1: 98.4689,
    x2: 121.463,
    y2: 77.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41A247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#4BA74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#67B554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B655"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/Mongo.85579f57e687766e3833e6b89f2d525d.svg";
export { ForwardRef as ReactComponent };